/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Russian language
 *
 * @file ru.js
 * @author Manimaran.S
 */

const ru = {
  'popularChannelSlider.allChannels': 'Все каналы',
  'popularChannelSlider.recommended': 'Рекомендуется',
  'hero.myetextbook.link': 'электронных книг',
  'hero.myetextbook.text': 'Не тот учебник? Получите доступ к своей библиотеке',
  'hero.etextfeaturestitle': 'Найдите учебные материалы в вашем учебнике eText',
  'hero.etextfeaturesdescription': 'Ваш учебник eText содержит учебные материалы, призванные помочь вам добиться успеха. Учитесь с помощью дидактических карт и других материалов прямо в вашем электронном учебнике.',
  'aichat.title1': 'Получите помощь, управляемую ИИ, по любому вопросу, связанному с этим учебником eText',
  'aichat.chatDesc1': 'Введите вопрос, чтобы начать',
  'subscriptiontext.isSubscribed': 'Входит в вашу подписку',
  'subscriptiontext.nonSubscriber': 'Обновите подписку для полного доступа',
  'topicConatiner.otherHeader': 'Связанные видео и практические материалы',
  'topicConatiner.exactLiteHeader': 'Связанные концепции и практические материалы',
  'moremenu.downloadApp': 'Загрузить приложение',
  'moremenu.downloadAppAlreadyDownload': '%Click here%, чтобы загрузить приложение на другое устройство и автоматически войти в систему или использовать свой уникальный QR-код для безопасного входа в уже установленное приложение.',
  'moremenu.downloadAppNotDownload': '%Click here%, чтобы загрузить приложение и безопасно войти в систему с помощью уникального QR-кода.',
  'channel.noBundletitle': 'Используйте «Подготовку к учебе» для связанных и прочих курсов',
  'onboard.studyPlan': 'Пользовательский план обучения создан!',
  'onboard.addCourseAnother': 'Хотите добавить еще один курс?',
  'onboard.purchase': 'Мне нужно приобрести электронный учебник Pearson',
  'onboard.addCourseWithoutEtext': 'Добавьте курс, используя «Подготовку к учебе»',
  'onboard.mayBeLater': 'Может быть, позже',
  'onboard.aboutCourse': 'Расскажите нам о своем курсе',
  'onboard.close': 'Закрыть',
  'course.addTitle': 'Добавить курс',
  'common.PURCHASE': 'Покупка',
  'common.CLOSE': 'Закрыть',
  'open': 'открыть',
  'continue': 'Продолжить',
  'yes': 'Да',
  'no': 'Нет',
  'audio': 'Аудио',
  'courses.toc.PUBLISH_SUCCESS': 'Успешно!',
  'courses.toc.PUBLISH_MESSAGE': 'Студенты увидят изменения в результате следующего открытия ими содержимого.',
  'errors.GENERIC_TITLE': 'У вас нет доступа к этому ресурсу в данный момент',
  'errors.GENERIC_DESC': 'Сначала обновите страницу или очистите кэш. Если это не поможет, обратитесь в ',
  'errors.GENERIC_LINK': 'службу поддержки Pearson.',
  'errors.GENERIC_CODE': 'Код ошибки: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Подписка не найдена',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Ваша учетная запись не предполагает доступа к этому заголовку. Если вы полагаете, \n    что получили это сообщение по ошибке, обратитесь в Службу технической поддержки Pearson',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Подписка не найдена',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Ваша подписка не предусматривает доступа к eText; тем не менее, \n    вы можете оформить подписку, используя кредитную карту.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Моя учетная запись',
  'menu.helpCenter': 'Справочный центр',
  'menu.preferencesCenter': 'Центр предпочтений',
  'menu.CONTACT_SUPPORT': 'Обратиться в Службы поддержки',
  'menu.HELP_SUPPORT': 'Справка и поддержка',
  'menu.FAQS': 'Часто задаваемые вопросы',
  'menu.CHAT_WITH_SUPPORT': 'Поговорить с поддержкой',
  'menu.OTP_CODES': 'Коды OTP',
  'menu.LAUNCH_CODE': 'Запустить журнал кодов',
  'menu.SEND_CODE': 'Отправить пользователю новый код по электронной почте',
  'menu.SEND_CODE_PHONE': 'Отправить пользователю новый код в текстовом сообщении',
  'menu.LEGAL': 'Правовые аспекты',
  'menu.PRIVACY_NOTICE': 'Уведомление о конфиденциальности',
  'menu.TITLE_INFO': 'Информация заголовка',
  'menu.PEARSON_ACCESSIBILITY': 'Доступ Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Регистрируйте {deviceLimit} устройств. Меняйте по 1 устройству в месяц.',
  'menu.ACCESSIBILITY': 'Доступ',
  'menu.ACCESSIBILITY_SUPPORT': 'Поддержка доступа',
  'menu.DEVICES': 'Недавние устройства',
  'menu.THIS_DEVICE': 'Это устройство',
  'menu.GET_THE_APP_DOWNLOAD': 'Загрузить приложение для мобильных устройств',
  'menu.MOJO_APP_INFO': 'Перейдите в магазин приложений на своем телефоне или планшете, чтобы использовать Pearson+ в автономном режиме.',
  'menu.DEVICE_LABEL': 'Устройство',
  'menu.DEVICE_DISCONNECT': 'Отключить',
  'menu.FOXIT': 'На платформе Foxit',
  'menu.TERMS_OF_USE': 'Условия использования',
  'menu.SIGN_OUT': 'Выйти',
  'menu.PRINT_PAGE': 'Печать страницы',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. Все права защищены.',
  'print.FOOTER_MESSAGE': 'Отпечатано {fullName}({email}), {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Вы уже заменили этот месяц',
  'device.SWITCH_DEVICE': 'Переключиться на текущее устройство?',
  'device.SWITCH_ONCE': 'Поскольку переключение возможно только один раз в месяц, вы не сможете отменить действие.',
  'device.SEAT_TAKEN': 'Это место занято',
  'device.DISCONNECT_DEVICE': 'Регистрация возможна только на трех устройствах. Чтобы продолжить, отключите одно их устройств.',
  'device.ALERT_TEXT': 'Помните: вы можете менять устройства один раз в месяц.',
  'device.DISCONNECT': 'Отключить',
  'device.CONTINUE': 'Продолжить',
  'device.HEADER': 'Завершить сеанс в другом браузере?',
  'device.CLOSE': 'На главную страницу',
  'device.CODE': 'Продолжите здесь, введя код подтверждения, который мы отправили на {maskedEmail}. Не работает? Проверьте папку «Спам», {email} или свяжитесь с {support}.',
  'device.TIMER': 'Введите код в течение {time}',
  'device.RESEND': '{resend}',
  'device.FAQ': 'Вопросы и ответы',
  'device.RESEND_NAME': 'Переслать',
  'device.NOTE': 'Если вы часто пользуетесь Pearson+ в двух разных местах, например дома и на работе, не забывайте выходить из аккаунта после завершения работы. Мобильное приложение Pearson+ можно использовать на двух устройствах. Дополнительную информацию см. в разделе {faq}.',
  'device.NOTE_HEADER': 'Избегайте этого в следующий раз',
  'device.CONTACT_SUPPORT': 'поддержка клиентов',
  'device.CONTACT_EMAIL': 'обновить адрес электронной почты',
  'device.INCORRECT': 'Неверно — проверьте код или запросите его повторно.',
  'device.MANY_ATTEMPTS': 'Слишком много попыток, запросите код повторно',
  'device.EXPIRED': 'Ваше время истекло, запросите код повторно',
  'device.ACCESS_HEADER': 'Вы вошли в систему!',
  'device.ACCESS_DESC': 'Ваши данные пользователя в рамках сеанса аутентифицированы. Хотите сразу изменить пароль?',
  'device.ACCESS_CHANGE_PASSWORD': 'Изменить пароль',
  'device.ACCESS_RESET_PASSWORD': 'Сброс пароля',
  'device.THREATONE_TITLE': 'Всё хорошо?',
  'device.THREATONE_DESC': 'Мы заметили подозрительную активность в вашей учетной записи.',
  'device.THREATONE_DESC_TWO': 'Советуем вам без промедления сменить пароль.',
  'device.MAY_BE_LATER': 'Может быть, позже',
  'device.OKAY': 'Принято',
  'device.ACCOUNT_LOCK_DESC': 'Для обеспечения безопасности мы вывели вас из системы. Мы отправили ссылку для смены пароля на электронную почту, связанную с вашей учётной записью.',
  'device.ACCOUNT_LOCK_TITLE': 'Мы заметили подозрительную активность в вашей учетной записи',
  'device.ACCOUNT_LOCK_TIMER': 'Вы будете выведены из системы {time}',
  'navigation.PAGE': 'Страница',
  'launchcode.CREATEBY': 'Создано:',
  'launchcode.sentvia': 'Отправлено через:',
  'launchcode.CODEINLAST': 'Коды в течение последних 7 дней:',
  'launchcode.TIMESENT': 'Время отправки:',
  'launchcode.ACCOUNTEMAIL': 'Электронная почта учетной записи:',
  'launchcode.LAUNCHDIALOGTITLE': 'Журнал кодов OTP',
  'textmessage.TITLE': 'Введите номер телефона',
  'textmessage.PHONE_NUMBER': 'Номер телефона',
  'textmessage.SEND_CODE': 'Отправить код',
  'textmessage.INVALID_NUMBER': 'Недействительный номер телефона.',
  'textmessage.SUCCESS_MESSAGE': 'Код отправлен',
  'remove.title': 'Удалить заголовок?',
  'remove.subTitle': 'Вы можете вернуться позже — выполните поиск для повторного добавления.',
  'remove.buttonText': 'Удалить',
  'search.searchPlaceHolderPPlus': 'Поиск по ISBN, названию или автору',
  'search.searchPlaceHolderEText': 'Поиск в библиотеке',
  'footer.downloadMobileApp': 'Загрузить приложение для мобильных устройств',
  'footer.termsOfUse': 'Условия использования',
  'footer.privacy': 'Конфиденциальность',
  'footer.cookies': 'Куки',
  'footer.doNotSellMyPersonalInformation': 'Не продавать мою личную информацию',
  'footer.accessibility': 'Доступ',
  'footer.patentNotice': 'Патентное уведомление',
  'footer.copyrights': 'Pearson. Все права защищены.',
  'hero.toc.defaultPlacehoder': '--- выберите тему ---',
  'hero.openEtextBookV1': 'Открыть электронный учебник',
  'hero.heroHeading': 'Потому что вы изучаете <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Подготовка к учебе',
  'hero.study.help': 'Получите помощь в учебе',
  'hero.study.jumpBackIn': 'Возвращайтесь!',
  'hero.study.numOfUsers': 'В настоящее время Каналы используют <b>{num_of_users}</b> учащихся.',
  'hero.heroChannel.cardsHeading': 'Продолжайте с того места, на котором остановились',
  'hero.marketingcard1.copy.title': 'Обучайтесь с помощью видеоматериалов',
  'hero.marketingcard1.copy.description': 'Смотрите видеоинструкции, раскрывающие сложные темы.',
  'hero.marketingcard2.copy.title': 'Практические задачи',
  'hero.marketingcard2.copy.description': 'Готовьтесь к экзаменам с помощью тысяч похожих вопросов и видеорешений.',
  'hero.marketingcard3.copy.title': 'Получите квалифицированную помощь',
  'hero.marketingcard3.copy.description': 'Задавайте вопросы и получайте ответы от экспертов в данной области.',
  'hero.popularTopics.heading': 'Другие популярные темы на этом канале',
  'hero.popularChannels.headingv1': 'Проходите другой курс?',
  'hero.popularChannels.descriptionv2': 'Просмотрите популярные темы для помощи в учебе.',
  'hero.practice': 'Тренировка',
  'hero.herobook.mappedChannelHeading': 'Рекомендуемая помощь в обучении на этом канале',
  'libraryL2.myBooks': 'Мои книги',
  'libraryL2.archived': 'Добавлено в архив',
  'libraryL2.back': 'Назад',
  'hero.practiceProblem': 'Практическое задание',
  'nativeAppBanner.drawer.title': 'Открыть в ...',
  'nativeAppBanner.drawer.pearsonApp': 'Приложение Pearson+',
  'nativeAppBanner.banner.title': 'Приложение Pearson+',
  'nativeAppBanner.banner.description': 'Изучайте на ходу',
  'hero.promotionalcard.list1': 'Небольшие видеоролики, в которых разбираются сложные темы',
  'hero.promotionalcard.list2': 'Тысячи вопросов, подобных экзаменационным',
  'hero.promotionalcard.list3': 'Получайте ответы от экспертов в данной области',
  'hero.studyandexamprep': 'Подготовка к учебе',
  'hero.heroBook.sectionSubHeadingV1': 'Разберите сложные темы с объясняющими видеоматериалами и практическими вопросами, адаптированными к вашему курсу.',
  'hero.heroBook.sectionSubHeadingV2': 'Разберите сложные темы с объяснениями концепций и практическими вопросами, адаптированными к вашему курсу.',
  'hero.SeeAllStudyOptions': 'Просмотреть все варианты обучения и подготовки',
  'hero.herobook.mappedChannelHeadingV1': 'Рекомендуемые видео и практические задания',
  'hero.popularTopics.headingV1': 'Другие популярные темы',
  'hero.heroHeadingV1': 'Для <span>{replace_value}</span>',
  'hero.learnmore': 'Узнать больше',
  'hero.eTextbook': 'Учебник eTextbook',
  'hero.goToPage.label': 'Перейти на страницу',
  'subscription.studyTitle': 'Подготовка к учебе',
  'print.printAvailTitle': 'Хотите распечатать эту страницу? Вот как вы можете это сделать',
  'print.printAvailDesc': 'В электронном учебнике выберите значок учетной записи в правом верхнем углу. В опциях выберите «Печать страницы», а затем выберите настройки печати.',
  'print.printNotAvailTitle': 'Печать этого eText не поддерживается.',
  'print.printNotAvailDesc': 'Скачайте своё издание в мобильном приложении Pearson+ для удобного офлайн‑доступа и учитесь в любое время и в любом месте!',
  'hero.header.cta': 'Перейти к учебным инструментам',
  'hero.header.ctav2': 'Открыть «Подготовку к учебе»',
  'hero.marketing.title': 'Найдите свой учебник eTextbook',
  'hero.marketing.subTitle': 'Выберите свою книгу из более чем 2000 электронных учебников с аудиозаписями, дидактическими картами, заметками и многим другим. Всего $10,99/мес за 4-месячный период.',
  'hero.popularchannels.desc': 'Получите помощь в изучении лучших предметов.',
  'hero.removecourse.title': 'Удалить курс с панели инструментов?',
  'hero.removecourse.description': 'Вы можете в любой момент вернуть курс обратно на панель инструментов, нажав Add course («Добавить курс»).',
  'hero.removecourse.primaryCtaText': 'Удалить',
  'hero.removecourse.secondaryCtaText': 'Отмена',
  'hero.tableOfContents': 'Оглавление',
  'hero.search': 'Поиск',
  'hero.emptystate.cta': 'Поиск в электронных учебниках',
  'hero.watch_it_again': 'Смотреть повторно',
  'hero.mondly.learnLang.title': 'Бесплатно выучите новый язык',
  'hero.mondly.subTitle': 'Пользователи электронных учебников Pearson получают три бесплатных месяца Mondly от Pearson.',
  'hero.mondly.description': 'Большинство приложений для изучения языков позволяют учиться только с базовым английским языком. Но лучше всего учиться на родном языке, поэтому Mondly позволяет вам обучаться на любом из 41 языка.',
  'hero.mondly.startLearningCTA': 'Начать обучение',
  'hero.mondly.marketing.bestApp': 'Лучшее приложение',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Приложение года',
  'hero.mondly.marketing.fbStart': 'Победитель программы Facebook FbStart – регион EMEA, 2017 год',
  'hero.mondly.marketing.editorChoice': 'Выбор редакции',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Выучите новый язык',
  'header.menu.moreAtPearson': 'Подробнее на сайте Pearson',
  'hero.subscriptionStatusTitle2': 'Ваши ресурсы Pearson+',
  'hero.startStudying': 'Начать обучение',
  'onboard.studyMaterials': 'Выберите свой предмет, и мы создадим приборную панель с индивидуальными учебными материалами.',
  'hero.myETextbooks': 'Мои учебники eTextbook',
  'header.continueInTheApp': 'Продолжить в приложении',
  'hero.learnTxt': 'Узнать',
  'hero.examPrepTxt': 'Подготовка к экзаменам',
  'hero.aITutorTxt': 'Репетитор на базе искусственного интеллекта',
  'AI.toolTip': 'Спросите меня о чем угодно в вашем учебнике eText',
  'hero.studyExamPrepAllYourCourses': '«Подготовка к учебе» по всем предметам',
  'header.qrCode.subHeaderTxt': 'С помощью QR-кода вы сможете быстро и безопасно войти в приложение Pearson+ на своем мобильном устройстве.',
  'header.qrCode.dontHaveApp': 'Нет приложения?',
  'header.qrCode.footerTxt': 'Отсканировав этот код, вы перейдете в App Store или Google Play. После загрузки приложения войдите в систему, просканировав код повторно.',
  'header.qrCode.errorMsg': 'QR-код не загрузился. Закройте и попробуйте снова.',
  'hero.yourETextbook': 'Ваш электронный учебник',
  'onboard.addCourseWithEtextBundle': 'Добавьте курс, используя «Подготовку к учебе»',
  'onboard.disableTooltipText': 'Все подготовительные курсы добавлены!',
  'subscriptionstatus.bundlecta': 'Получите доступ к «Подготовке к учебе»',
  'subscriptionstatus.nonbundlecta': 'Получите доступ к «Подготовке к учебе»',
  'channel.genericBundle': 'Используйте свой пакет «Подготовки к учебе» для других курсов',
  'channel.relatedBundle': 'Также используйте свой пакет «Подготовки к учебе» для других курсов',
  'onboard.courseAdded': 'Курсы добавлены!',
  'hero.flashcards': 'Дидактические карты',
  'relatedChannelCard.title': 'Расширьте возможности обучения с помощью этого ресурса',
  'relatedChannelCard.badgeText': 'Сопутствующие пакеты «Подготовки к учебе»',
  'sessionInactivity.title': 'Вы все еще здесь?',
  'sessionInactivity.description': 'Ваш сеанс завершится через <b>%TIMER%</b> по причине отсутствия активности.<br/>Хотите оставаться в системе?',
  'sessionInactivity.keepMeSignIn': 'Оставаться в системе',
  'sessionInactivity.signOut': 'Выйти',
  'sessionTimeout.title': 'Время сеанса истекло',
  'sessionTimeout.description': 'Ваш сеанс завершен по причине отсутствия активности.',
  'print.qrCode.header': 'С помощью QR-кода вы сможете открыть приложение Pearson+ на своем мобильном устройстве.',
  'print.qrCode.footer': 'Отсканировав этот код, вы перейдете в App Store или Google Play. После установки приложения войдите в систему для загрузкии доступа к материалу.',
  'hero.nestest.title': 'Подготовьтесь к экзамену на учительскую сертификацию',
  'hero.nestest.subTitle': 'Пользователям Pearson+ теперь доступны подготовительные курсы и практические тесты, разработанные в соответствии с национальными требованиями, чтобы помочь им подготовиться к экзаменам на получение учительской сертификации.',
  'hero.channelAI.title': 'Нужна помощь? ИИ-репетитор всегда к вашим услугам.',
  'hero.channelAI.desc': 'Задайте вопрос и получите пошаговую помощь с домашними заданиями, рекомендации по учебе и многое другое — персональная помощь в любое время и по мере необходимости.',
  'hero.channelAI.action': 'Обратитесь к ИИ-репетитору прямо сейчас!',
  'new': 'Новинка!',
  'hero.practice.numOfUsers': 'В этом разделе есть <b>{practice_num_of_users}</b> практических заданий.',
  'hero.practice.cta': 'Приступить к практике',
  'hero.practice.title': 'Практическое задание',
  'diagnostics.errorMsg': 'Диагностика не загрузилась. Закрой и попробуй снова.',
  'qrcode.title': 'Начните учиться в любом месте',
  'qrcode.subtitle': 'Учитесь в любом месте и в любое время с мобильным приложением Pearson+. Скачайте сейчас и наслаждайтесь максимально удобным учебным процессом.',
  'qrcode.detailsv1': 'С приложением Pearson+ вы можете использовать этот QR‑код, чтобы продолжить с того места, где остановились. Выполняйте поиск по книге, работайте с карточками, просматривайте видеоуроки и пользуйтесь другими функциями в любом месте.',
  'qrcode.detailsv2': 'Сканируйте этот QR‑код, чтобы быстро войти и продолжить с того места, где остановились.',
  'qrcode.details': 'С приложением Pearson+ вы можете использовать этот QR‑код, чтобы продолжить с того места, где остановились.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Учитесь в любом месте и в любое время с мобильным приложением Pearson+. Скачайте сейчас и наслаждайтесь максимально удобным учебным процессом.',
  'install': 'Install',
  'header.menu.createCourse': 'Новый курс',
  'header.dropdown.courses': 'Курсы',
  'header.dropdown.recentlyViewed': 'Недавно просмотренные ресурсы',
  'header.dropdown.viewAll': 'Просмотреть все курсы',
  'aet.courseHeader.inviteStudents': 'Пригласить студентов',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Скопируйте ссылку или инструкции ниже в письмо или учебную программу, чтобы пригласить студентов к eTextbook.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Адрес ссылки',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Скопировать ссылку',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Инструкции с адресом ссылки',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Скопировать инструкции',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'Пора получить доступ к {bookTitle} eTextbook для {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'Когда будете готовы, перейдите к своему электронному учебнику по адресу: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Вам будет предложено войти в свой существующий аккаунт Pearson. Если у вас его нет, вы сможете создать новый.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Необходима помощь?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Дата начала:',
  'aet.courseHeader.endDate': 'Дата окончания:',
  'aet.courseHeader.start': 'Start:',
  'aet.courseHeader.end': 'End:',
  'aet.courseHeader.moreOptions': 'More options',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Формат:',
  'aet.home.manageroster': 'Управление списком',
  'aet.home.managegradesync': 'Управление синхронизацией оценок',
  'aet.home.copycourse': 'Создать копию курса',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',

  'aet.instructorCourse.tabs.current': 'Текущий',
  'aet.instructorCourse.tabs.past': 'Прошедшее',
  'aet.instructorCourse.tabs.courseSettings': 'Настройки курса',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Управление списком',
  'aet.instructorCourse.currentCourses.title': 'Текущие курсы',
  'aet.instructorCourse.pastCourses.title': 'Прошедшие курсы',
  'aet.instructorCourse.archivedCourses.title': 'Archived courses',
  'aet.instructorCourse.archivedCourses.description': 'Archived titles are hidden from Current and Past. Your access to each title doesn’t change — unarchive it any time to put it back on your bookshelf.',
  'aet.instructorCourse.archivedCourses.emptyStateTitle': 'No archived titles',
  'aet.instructorCourse.archivedCourses.emptyStateDescription': 'Archive a title from Current or Past using its ··· menu. It moves here without changing your access.',
  'aet.instructorCourse.archiveDialog.title': 'Archive title(s)',
  'aet.instructorCourse.archiveDialog.description': 'Archived titles will move to the Archived tab, and all courses that use that title will be archived. They can still be accessed from the archived section, directly from the MLM course, and from Console. You can unarchive it anytime from the Archived tab.',
  'aet.instructorCourse.archiveDialog.confirmCTA': 'Archive',
  'aet.instructorCourse.unarchiveDialog.title': 'Unarchive title(s)',
  'aet.instructorCourse.unarchiveDialog.description': 'Unarchived titles will be accessible from your home page.',
  'aet.instructorCourse.unarchiveDialog.confirmCTA': 'Unarchive',
  'aet.home.archiveCourse': 'Archive',
  'aet.home.unarchiveCourse': 'Unarchive',
  'aet.instructorCourse.createOrCopy.title': 'Создать или скопировать курс Pearson eTextbook',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Скопировать курс другого преподавателя или создать новый',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Скопировать курс другого преподавателя',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Введите ID курса, чтобы найти курс для копирования.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID курса',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Ввести ID курса',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Вы искали:',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Создайте новый курс из каталога',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Поиск по названию, автору, ISBN или тематическим ключевым словам.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Поиск...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Показать больше',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Показать меньше',
  'aet.instructorCourse.cancel': 'Отмена',
  'aet.instructorCourse.loading': 'Загрузка данных...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Синхронизация оценок',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Управление синхронизацией оценок',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Название курса',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Без названия',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Название раздела',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Без названия',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Учебное заведение',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Необходимо указать учебное заведение',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Произошла ошибка! Попробуйте ещё раз.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Результаты отсутствуют',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.startDateLabel': 'Дата начала курса',
  'aet.instructorCourse.courseForm.endDateLabel': 'Дата окончания курса',
  'aet.instructorCourse.courseForm.datePlaceholder': 'дд/мм/гг',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Предоставить другим возможность копировать данный курс',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Поделитесь этим кодом с преподавателями, которые хотят скопировать курс',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Копировать код',
  'aet.instructorCourse.courseForm.optionalSuffix': '(необязательно)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Форма содержит ошибки проверки данных',
  'aet.instructorCourse.courseForm.submitContinue': 'Продолжить',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Сохранение...',
  'aet.instructorCourse.courseForm.submitError': 'Создать курс не удалось. Пожалуйста, повторите попытку.',
  'aet.instructorCourse.courseForm.submitEditError': 'Мы не смогли сохранить ваши изменения. Пожалуйста, повторите попытку.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Сохранить изменения',
  'aet.instructorCourse.courseForm.materialsHeader': 'Материалы курса',
  'aet.instructorCourse.courseForm.resolveError': 'Мы не смогли загрузить материалы курса. Пожалуйста, повторите попытку.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Недавно просмотренные',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Добавлены недавно',
  'aet.instructorCourse.coursesSort.aToZ': 'А - Я',
  'aet.instructorCourse.coursesSort.zToA': 'Я - А',
  'aet.instructorCourse.manageRoster.column.name': 'Имя, фамилия',
  'aet.instructorCourse.manageRoster.column.role': 'Роль',
  'aet.instructorCourse.manageRoster.column.email': 'Электронная почта',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Статус',
  'aet.instructorCourse.manageRoster.column.statusInfoTooltip': 'Status information',
  'aet.instructorCourse.manageRoster.statusInfoModal.title': 'Status',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph1': 'This status reflects Pearson enrollment and may not match a student\'s enrollment status in your linked LMS course.',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph2': 'Students marked as Inactive will not have grades synced back to the LMS.',
  'aet.instructorCourse.manageRoster.access.tempAccessTitle': 'Temporary access',
  'aet.instructorCourse.manageRoster.access.active': 'Active eTextbook access',
  'aet.instructorCourse.manageRoster.access.endsOn': 'Ends: {date}',
  'aet.instructorCourse.manageRoster.access.ended': 'Ended:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.roster.role.student': 'Студент',
  'aet.instructorCourse.roster.role.ta': 'TA',
  'aet.instructorCourse.roster.role.instructor': 'Инструктор',
  'aet.instructorCourse.roster.status.active': 'Активно',
  'aet.instructorCourse.roster.status.inactive': 'Неактивно',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Все участники курса',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Активные студенты',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Неактивные студенты',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Помощник преподавателя',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Инструктор',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Автор:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Дата создания курса:',
  'aet.instructorCourse.noCoursesFound': 'Курсы не найдены',
  'aet.instructorCourse.searchNoResultsTitle': 'No courses match “{searchTerm}”',
  'aet.instructorCourse.searchNoResultsDescription': 'Try a different course name.',
  'aet.instructorCourse.clearSearch': 'Clear search',
  'aet.instructorCourse.noCoursesEmptyStateTitle': 'Nothing here yet',
  'aet.instructorCourse.noCoursesEmptyStateDescription': 'Courses you create or are added to will appear here.',
  'aet.instructorCourse.backButton': 'Назад',
  'aet.instructorCourse.selectCourse': 'Выбрать курс',
  'aet.home.linkedToLms': 'Курс связан с LMS',
  'aet.instructorCourse.courseForm.title.create': 'Создать курс',
  'aet.instructorCourse.courseForm.title.copy': 'Создать копию курса',
  'aet.instructorCourse.courseForm.title.edit': 'Информация курса',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Настройки',
  'aet.studentRoster.manageStudentRosterButton': 'Управление списком студентов',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Экспортировать данные об успеваемости учащегося',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Статус:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Зачислен:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Роль:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Повысить {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'В роли помощника преподавателя этот пользователь получит доступ к прогрессу и успеваемости всех студентов класса.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Они также смогут управлять студентами и заданиями, однако не смогут удалить класс.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Сделать помощником преподавателя',
  'aet.home.manageRoster.searchPlaceholder': 'Поиск студента',
  'aet.home.manageRoster.inactivateButtonLabel': 'Деактивировать выбранных студентов',
  'aet.home.manageRoster.FilterLabel': 'Показать',
  'aet.home.manageRoster.updatingMessage': 'Идёт обновление списка студентов… Это может занять несколько минут.',
  'aet.home.courses.search.searchPlaceHolder': 'Искать среди ваших курсов',
  'aet.courses.emptyStateDescription': 'Начните формировать курс, выбрав один из вариантов ниже.',
  'nativePromoBanner.continueInBrowser': 'Продолжить в браузере',
  'globalnav.tooltip.hideNavText': 'Скрыть навигацию',
  'globalnav.tooltip.showNavText': 'Показать навигацию',
  'aet.syllabus.progressTitle': 'Извлечение...',
  'aet.syllabus.progressDesc': 'Пожалуйста, подождите. Идёт обработка вашего учебного плана.',
  'aet.syllabus.uploadInputLabel': 'Перетащите файлы или нажмите, чтобы загрузить',
  'aet.syllabus.uploadSyllabusTabLabel': 'Загрузите учебный план',
  'aet.syllabus.dateAdjusterTabLabel': 'Настройка даты',
  'aet.syllabus.addManuallyTabLabel': 'Добавить задания вручную',
  'aet.syllabus.addEditLaterText': 'Вы всегда можете добавить и отредактировать задания позже',
  'aet.syllabus.editAssignmentLabel': 'Редактировать задание',
  'aet.syllabus.addAssignmentLabel': 'Добавить задание',
  'aet.syllabus.assignmentTitleLabel': 'Название задания',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Срок сдачи',
  'aet.syllabus.editDueDateLabel': 'Редактировать срок сдачи',
  'aet.syllabus.chaptersCoveredLabel': 'Отметьте главы или разделы, которые нужно пройти.',
  'aet.syllabus.updateCtaLabel': 'Обновить задание',
  'aet.syllabus.addCtaLabel': 'Добавить задание',
  'aet.syllabus.uploadLabel': 'Загрузить',
  'aet.syllabus.confirmLabel': 'Подтвердить',
  'aet.syllabus.addContentLabel': 'Добавить содержимое',
  'aet.syllabus.addEditContentLabel': 'Добавить/редактировать контент',
  'aet.syllabus.notPublishedLabel': 'Не опубликовано',
  'aet.syllabus.updateDatesLabel': 'Обновить дату',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Срок сдачи был обновлён. Проверьте его, затем опубликуйте.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Информация о вашей главе/разделе была обновлена. Проверьте её, затем опубликуйте.',
  'aet.syllabus.unassignedCoverageStatus': 'Некоторые главы ещё не назначены. Назначьте их перед публикацией.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': 'Удалить задание?',
  'aet.deleteAssignmentTitleMultiple': 'Удалить задания?',
  'aet.deleteAssignmentWarning': 'Эту операцию нельзя отменить. Все связанные задания и информация о студентах будут скрыты.',
  'aet.deleteAssignmentKeepCTA': 'Сохранить задание',
  'aet.deleteAssignmentDeleteCTA': 'Удалить',
  'aet.assignments.loadingAsset': 'Загрузка ресурса...',
  'aet.assignments.addToDate': 'Добавить к дате',
  'aet.assignments.previewAsStudent': 'Просмотр как студент',
  'aet.assignments.questionsAndTopics': 'Вопросы и темы',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Готово',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Срок сдачи',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Всего вопросов',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'Вопрос {count} из {total}',
  'aet.assignments.questionsAndTopicsModal.sectionSelectLabel': 'Select a section',
  'aet.assignments.publishToStudents': 'Опубликовать для студентов',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Добавить дату',
  'aet.assistedSchedule.addToAssignmentModalTitle': 'Add to assignment',
  'aet.assistedSchedule.addToAssignmentModalEmptyLabel': 'No content yet',
  'aet.doneLabel': 'Готово',
  'aet.assignments.dueDateLabel': 'Крайний срок сдачи задания',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now:',
  'aet.onboarding.getStarted.manualSetup.title': 'Настройка вручную',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.manualSetup.ctaLabel': 'Create manually',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Weekly schedule',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Pick a due day that repeats all term, then drag chapters into each week',
  'aet.onboarding.getStarted.assistedScheduling.ctaLabel': 'Build schedule',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Turn assigned reading into active learning',
  'aet.onboarding.promotion.feature.1': 'Quickly create assignments with embedded questions, plus optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Получайте актуальные данные, чтобы замечать пробелы в обучении и вовремя принимать меры',
  'aet.onboarding.promotion.feature.3': 'Студенты получают больше поддержки благодаря персонализированной обратной связи и встроенному Pearson AI',
  'aet.onboarding.getStarted.previewQuestions.prompt': 'Want to see what’s available?',
  'aet.onboarding.getStarted.previewQuestions.link': 'Preview all questions',
  'aet.questionPreview.title': 'Preview questions',
  'aet.questionPreview.chapterSelectLabel': 'Select chapter',
  'aet.questionPreview.questionLabel': 'question',
  'aet.questionPreview.questionsLabel': 'questions',
  'aet.questionPreview.correctAnswer': 'Correct answer',
  'aet.questionPreview.noQuestions': 'No questions are available for this chapter.',
  'aet.assistedSchedule.pageTitle': 'Weekly schedule',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set up a weekly schedule',
  'aet.assistedSchedule.sectionDescription': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysLabel': 'Have assignments due every',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose one or more days of the week',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.viewQuestions': 'View questions',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Start assignments by',
  'aet.assistedSchedule.endDateLabel': 'End assignments by',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.autoNameAssignmentsLabel': 'Automatically name assignments based on content',
  'aet.assistedSchedule.autoNameAssignmentsInstruction': 'Assignment names will be generated from the content.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assistedSchedule.addNewLabel': 'Add new',
  'aet.assistedSchedule.addToNewAssignmentLabel': 'Add to new assignment',
  'aet.assistedSchedule.saveAsDraftLabel': 'Save as draft',
  'aet.assistedSchedule.saveAndPublishLabel': 'Save and publish',
  'aet.assignments.allCaughtUpDescription': 'Все задания на эту неделю выполнены.',
  'aet.assignments.progressTitle': 'Ход выполнения',
  'aet.assignments.performanceTitle': 'Уверенность',
  'aet.assignments.completionTitle': 'Завершение',
  'aet.assignments.statusTitle': 'Статус',
  'aet.assignments.addTooltip': 'Добавить задание',
  'aet.assignments.deleteTooltip': 'Удалить отмеченные задания',
  'aet.assignments.selectToDeleteLabel': 'Режим выбора и удаления',
  'aet.assignments.bulkEditTooltip': 'Массовое редактирование заданий',
  'aet.assignments.title': 'Задания',
  'aet.assignments.assignmentTitle': 'Задание',
  'aet.assignments.dueDate': 'Срок сдачи',
  'aet.tabular.searchPlaceholder.assignments': 'Поиск заданий',
  'aet.tabular.searchPlaceholder.students': 'Поиск студентов',
  'aet.tabular.searchPlaceholder.questions': 'Поиск вопросов',
  'aet.assignemnts.columnDueDateInfoTooltip': 'У одного или нескольких студентов продлены сроки сдачи всех заданий',
  'aet.assignemnts.singleDueDateInfoTooltip': 'У одного или нескольких студентов продлены сроки сдачи для этого задания',
  'aet.assignemnts.masterDueDateInfoTooltip': 'У одного или нескольких студентов продлены сроки сдачи. Ищите значок «Info», чтобы определить такие задания.',
  'aet.home.loading': 'Загрузка данных...',
  'aet.home.errorFetchingAssignments': 'Ошибка при получении заданий',
  'aet.home.dueThisWeekTitle': 'Срок сдачи на этой неделе',
  'aet.home.allCaughtUpTitle': 'Вы завершили все задания!',
  'aet.home.allCaughtUpDescription': 'Все задания на эту неделю выполнены.',
  'aet.home.suggestedRemediationTitle': 'Рекомендуемый обзор от «Подготовки к учебе»',
  'aet.home.noSuggestedRemediationTitle': 'Рекомендуемого материала для повторения нет',
  'aet.home.noSuggestedRemediationDescription': 'Проверьте после вашего следующего задания.',
  'aet.home.assignmentIncludesTitle': 'Задание включает',
  'aet.home.sectionsLabel': 'Глава(ы)',
  'aet.home.questionsCount': '{count} вопрос(а/ов)',
  'aet.home.dueLabel': 'Срок сдачи: {dueDate}',
  'aet.home.due': 'Срок сдачи:',
  'aet.home.progressCompletedLabel': 'Выполнено',
  'aet.home.progressCompletedPastDueLabel': 'Выполнено после установленного срока сдачи',
  'aet.home.progressInProgressLabel': 'Выполняется',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'Не начато',
  'aet.home.progressCountOfTotal': '{count} из {total}',
  'aet.home.NotAttemptedLabel': 'Не начато',
  'aet.home.questionsTotalLabel': 'Итого вопросов',
  'aet.home.progressCompletedOnTimeLabel': 'Выполнено вовремя',
  'aet.home.segmentGreatLabel': 'Отлично',
  'aet.home.segmentGettingThereLabel': 'Принято',
  'aet.home.segmentNeedsReviewLabel': 'Требует доработки',
  'aet.home.segmentOkayLabel': 'Принято',
  'aet.home.editAssignmentTooltip': 'Редактировать задание',
  'aet.home.deleteAssignmentTooltip': 'Удалить задание',
  'aet.home.viewDetailsButton': 'Подробнее',
  'aet.home.viewAsStudentButton': 'Просмотреть как студент',
  'aet.home.welcomeButtonText': 'Приступить →',
  'aet.review.emptyStateTitle': 'Материалы для повторения отсутствуют',
  'aet.review.emptyStateDescription': 'Проверьте после вашего следующего задания.',
  'aet.dashboard.tabs.upNext': 'Следующее',
  'aet.dashboard.tabs.welcome': 'Приветствуем!',
  'aet.dashboard.tabs.assignments': 'Задания',
  'aet.dashboard.tabs.review': 'Просмотреть',
  'aet.dashboard.tabs.studentRoster': 'Студенты',
  'aet.dashboard.classSchedule': 'Расписание занятий:',
  'aet.syllabus.dueTimeLabel': 'Срок сдачи',
  'hero.accessEducatorGuides': 'Открыть материалы для преподавателей',
  'aet.assignment.save': 'Сохранить',
  'aet.assignment.finish': 'Завершить',
  'aet.assignment.saveAndAdd': 'Сохранить и добавить ещё',
  'aet.assignment.delete': 'Удалить',
  'aet.assignment.saveAndClose': 'Сохранить и закрыть',
  'aet.studentRoster.title': 'Студенты',
  'aet.studentRoster.titlev1': 'Студент',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Сроки сдачи',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Стандартный',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 дня',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 дня',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 дней',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 неделя',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 недели',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Последний день занятий',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} of {total} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '{skippedCount} assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'No assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'All assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.success.title.multiple': '{count} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.single': 'New due dates have been added to <b>{assignmentTitle}</b>.',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.multiple': 'New due dates have been added to multiple assignments.',
  'aet.bulkEdit.bulkSplitInstruction': 'Мы равномерно распределим ваши задания.',
  'aet.bulkEdit.Description': 'Компонентный вариант основного слоя. Библиотека редактора, устройство, авто‑звезда, горизонтальное изменение размера карандашом. Многоугольник, основной список, FigJam, звёздная раскладка, объект, соединение, масштаб рукой.',
  'aet.bulkEdit.firstAssignmentDue': 'Срок сдачи первого задания',
  'aet.bulkEdit.lastAssignmentDue': 'Срок сдачи последнего задания',
  'aet.bulkEdit.assignmentsDueDays': 'На какие дни вы хотите поставить сроки сдачи заданий?',
  'aet.bulkEdit.addEditLaterText': 'Мы используем ИИ для создания заданий. Вы всегда можете добавлять и редактировать задания позже.',
  'aet.bulkEdit.monday': 'Понедельник',
  'aet.bulkEdit.tuesday': 'Вторник',
  'aet.bulkEdit.wednesday': 'Среда',
  'aet.bulkEdit.thursday': 'Четверг',
  'aet.bulkEdit.friday': 'Пятница',
  'aet.bulkEdit.saturday': 'Суббота',
  'aet.bulkEdit.sunday': 'Воскресенье',
  'aet.toast.assignmentCreated.title': '1 assignment created',
  'aet.toast.assignmentCreated.title.multiple': '{count} assignments created',
  'aet.toast.assignmentCreated.single': 'Assignment was named <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentCreated.multiple': 'Assignment names were also added.',
  'aet.toast.assignmentUpdated.title': 'Успешно обновлено.',
  'aet.toast.assignmentUpdated.title.single': '1 assignment updated',
  'aet.toast.assignmentUpdated.single': 'Your changes have been saved to <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentUpdated.multiple': '{count} задания(ий) обновлены',
  'aet.toast.assignmentPublished.single': '{count} assignment published',
  'aet.toast.assignmentPublished.multiple': '{count} assignments published',
  'aet.toast.assignmentPublished.subtitle': 'Редактирование задания доступно до тех пор, пока студенты не начнут работу.',
  'aet.toast.assistedScheduleCreated.single': '{count} Assignment created!',
  'aet.toast.assistedScheduleCreated.multiple': '{count} Assignments created!',
  'aet.toast.assistedScheduleCreated.subtitle': 'Default assignment titles were updated based on content.',
  'aet.toast.assistedSchedulePublished.single': '{count} Assignment published!',
  'aet.toast.assistedSchedulePublished.multiple': '{count} Assignments published!',
  'aet.toast.viewAssignment': 'Посмотреть задание',
  'aet.toast.viewAssignments': 'Посмотреть задания',
  'aet.welcome.title': 'Ваш электронный учебник Pearson теперь связан с вашим курсом в LMS',
  'aet.welcome.LMSAccounTitle': 'Изучайте аналитику',
  'aet.welcome.LMSAccounDescription': 'Посматривайте, с какими темами ваш класс испытывает трудности.',
  'aet.welcome.createAssignmentsTitle': 'Создавайте задания',
  'aet.welcome.createAssignmentsDescription': 'Назначайте главы вручную или загружайте свой учебный план.',
  'aet.welcome.progressViewTitle': 'Отслеживайте успеваемость в вашей системе управления обучением',
  'aet.welcome.progressViewDescription': 'Выберите настройки синхронизации оценок в вашем курсе в системе управления обучением.',
  'aet.assignmentDetails.noAssignmentFound': 'Задания не найдены',
  'aet.assignments.loadingErrorTitle': 'Задание сейчас не может быть загружено',
  'aet.assignments.loadingErrorDescription': 'Попробуйте перезагрузить страницу или вернитесь позже.',
  'aet.assignmentStudentDetails.noDataFound': 'Данные пока отсутствуют',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Нет зарегистрированных студентов',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Студенты присоединятся к вашему курсу при покупке электронного учебника.',
  'aet.home.editAssignmentTooltipDisabled': 'Редактирование недоступно: студенты выполняют задание',
  'aet.home.deleteAssignmentTooltipDisabled': 'Удаление недоступно: студенты выполняют задание',
  'aet.home.StudentDetails.questions': 'Вопросы',
  'aet.home.StudentDetails.attempts': 'Попытки',
  'aet.home.StudentDetails.comprehension': 'Уверенность',
  'hero.titleInfo.tooltip': 'Информация о заголовке',
  'aet.home.publishAssignments': 'Опубликовать все задания',
  'aet.assignments.saveScheduleAsDraft': 'Сохранить расписание как черновик',
  'aet.assignments.reviewBeforePublishAlert': 'Просмотрите задания, затем опубликуйте их, чтобы сделать видимыми для студентов.',
  'aet.assignments.copiedCoursePublishAlert': 'Добавьте даты к скопированным заданиям и опубликуйте, чтобы открыть доступ студентам.',
  'aet.assignments.allSetPublishAlert': 'Готово? Опубликуйте задания, чтобы сделать их видимыми для студентов.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Определенный контент создан с использованием ИИ на основе учебных материалов Pearson. Не смотря на то, что Pearson проверяет информацию на выходе, генеративный ИИ всё же может выводить неточную информацию о людях, местах или фактах.',
  'aet.home.bulkEditTitle': 'Редактировать задания массово',
  'aet.home.bulkEditSubtitle': 'Внесите изменения в свой учебный план, затем загрузите его здесь повторно. Ваши задания и сроки сдачи будут обновлены соответственно.',
  'aet.home.createAssignmentTitle': 'Создавайте задания',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Включено в другое задание',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Некоторые разделы включены в другое задание',
  'aet.welcome.welcome.Title': 'Приветствуем!',
  'aet.home.student.roaster.ProgressTitle': 'Общий прогресс',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Проверьте позже, когда студенты приступят к заданию.',
  'aet.home.whatDueThisWeekTitle': 'Задания на эту неделю',
  'aet.assignments.edit.errorTitle': '{count} задания содержат ошибки',
  'aet.assignments.edit.errorSubTitle': 'Задания с ошибками нельзя опубликовать. Отредактируйте их или опубликуйте без них.',
  'aet.assignments.edit.publishAnyway': 'Всё равно опубликовать',
  'aet.assignments.edit.editAssignments': 'Редактировать задания',
  'aet.assignments.edit.validationInfoToolTip': 'Отредактируйте задание, чтобы устранить ошибки',
  'aet.assignments.error.assignmentCreated.title': 'Все задания содержат ошибки',
  'aet.assignments.error.assignmentCreated.description': 'Задания с ошибками нельзя опубликовать. Исправьте их или используйте другой учебный план.',
  'aet.assignments.error.uploadSyllabus': 'Загрузите учебный план',
  'aet.assignments.error.editAssignments': 'Редактировать задания',
  'aet.mondly.title': 'Языки',
  'aet.studentRoster.errorState.title': 'Список студентов недоступен',
  'aet.studentRoster.errorState.description': 'Не удалось загрузить список студентов. Попробуйте перезагрузить страницу или вернитесь позже.',
  'aet.assignments.sectionLabel': 'раздел(ы)',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.tags.dueNext': 'Due next',
  'aet.assignments.tags.pastDue': 'Past due',
  'aet.assignments.completionLabel': 'answered',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'вопрос(ы)',
  'aet.assignments.assignmentsLabel': 'задание(я)',
  'aet.assignments.performanceProgressBar': 'Индикатор прогресса выполнения',
  'aet.assignments.completionProgressBar': 'Индикатор прогресса завершения',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Вы уверены, что хотите удалить это задание?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Вы уверены, что хотите удалить эти задания?',
  'aet.home.nextAssignmentTitle': 'Следующее задание',
  'aet.home.courseSettings': 'Настройки курса',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Материалы eTextbook Pearson+',
  'aet.home.etextbookInformation': 'Информация об электронном учебнике',
  'aet.multiple.deleteAssignmentKeepCTA': 'Сохранить задание(я)',
  'aet.syllabus.processingText.header': 'Мы приводим в порядок назначенные вашему классу материалы для чтения – это займёт всего минуту.',
  'aet.syllabus.processingText.uploading': 'Загрузка вашего документа',
  'aet.syllabus.processingText.activating': 'Активация компонентов искусственного интеллекта',
  'aet.syllabus.processingText.extracting': 'Извлечение материалов для чтения',
  'aet.syllabus.processingText.mapping': 'Сопоставление с содержанием учебника',
  'aet.syllabus.processingText.finishing': 'Завершение',
  'aet.syllabus.uploadErrorMessage': 'Проверьте, что размер вашего PDF или .docx не превышает 10 MB, и что интернет‑соединение остаётся стабильным.',
  'aet.syllabus.uploadNoAssignmentsMessage': 'Назначенные задания для чтения не найдены',
  'aet.syllabus.uploadNoAssignmentsDescription': 'Не удалось получить задания для чтения из этого файла. Вы можете добавить их вручную.',
  'aet.syllabus.uploadFailedRetryCTA': 'Повторите попытку',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Перепроверьте, что учебный план содержит <qualities a syllabus should have for this to work>, затем повторите попытку или создайте задания вручную.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Создание вручную',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Произошла ошибка',
  'aet.syllabus.uploadModal.genericFailure.body1': 'Не удалось загрузить и обработать учебный план',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Проверьте соединение и повторите попытку; при необходимости создайте задания вручную.',
  'aet.syllabus.uploadModal.successTotal.title': 'Готово для проверки',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'Готово для проверки',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Проверьте задания',
  'aet.syllabus.selectChapterWithQuestions': 'Выберите раздел с вопросами.',
  'preferenceSetting.subTitle': 'Эти настройки будут применяться по умолчанию для всех студентов этого курса.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Взаимодействие с ИИ',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Активировать инструмент обучения ИИ и ИИ‑резюме в результатах поиска',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Показать материалы для Подготовки к учебе, связанные с этой книгой',
  'aet.syllabus.footer': 'Создание заданий осуществляется с использованием технологий ИИ',
  'aet.dashboard.footerDialogDeatils': 'Генеративный ИИ применяется для создания вопросов к заданиям на основе учебных материалов Pearson. Несмотря на то что Pearson осуществляет проверку сгенерированного контента, генеративный ИИ может содержать неточности в сведениях о людях, местах или фактах. Кроме того, ИИ используется для группировки материалов в задания – в соответствии с предоставленной программой курса и/или расписанием.',
  'aet.review.footer': 'Создано с использованием ИИ',
  'aet.footerCard.dismiss': 'Отклонить',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Раздел «Подготовка к учёбе» – это дополнительный инструмент, который помогает в обучении, предлагая студентам видеоматериалы и практические задания, адаптированные под этот курс.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Если в вашем плане нет «Подготовки к учёбе», вам может потребоваться оформить подписку, чтобы продолжить пользоваться этими материалами.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'На студентов, которые уже приобрели раздел «Подготовка к учёбе», эта настройка не повлияет.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Узнайте больше о преимуществах раздела «Подготовка к учёбе»',
  'aet.home.viewCourseId': 'Показать ID курса',
  'aet.home.copy': 'Копировать',
  'aet.home.copied': 'Скопировано',
  'aet.home.courseLabel': 'ID курса:',
  'schoolInfoCard.addUniversity': 'Добавьте учебное заведение',
  'schoolInfoCard.title': 'Информация об учебном заведении',
  'schoolInfoCard.titleV1': 'Расскажите нам о своем курсе',
  'schoolInfoCard.cta': 'Приступить',
  'schoolInfoCard.pickInstitution': 'Выберите учебное заведение',
  'schoolInfoCard.addUniversityTitle': 'Добавьте своё учебное заведение',
  'schoolInfoCard.addUniversitySubtitle': 'Знание вашего учебного заведения и курса позволяет нам рекомендовать наиболее полезные учебные материалы.',
  'schoolInfoCard.searchPlaceholder': 'Найдите своё учебное заведение…',
  'schoolInfoCard.skip': 'Пропустить этот шаг',
  'schoolInfoCard.nextStep': 'Следующий шаг',
  'schoolInfoCard.notInList': 'Моего учебного заведения нет в списке',
  'schoolInfoCard.noResults': 'Учебные заведения, соответствующие вашему запросу, не найдены',
  'schoolInfoCard.noResultsHeading': 'Не можете найти своё учебное заведение?',
  'schoolInfoCard.noResultsInstruction': 'Укажите полное имя ниже',
  'schoolInfoCard.noResultsInputPlaceholder': 'Название учебного заведения',
  'schoolInfoCard.addInstitutionLabel': 'Добавьте это учебное заведение',
  'aet.assignments.assignmentTitlePlaceholder': 'Введите название',
  'aet.assignments.titleValidation.titleRequired': 'Название задания обязательно.',
  'aet.assignments.titleValidation.titleTooLong': 'Название задания не может превышать {0} символов.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Название задания содержит недопустимые символы.',
  'aet.assignments.titleValidation.titleDuplicate': 'Название задания уже существует',
  'aet.syllabus.timeZoneLabel': 'Часовой пояс',
  'aet.review.reviewReadingFromAssignments': 'Изучите текст, указанный в задании',
  'aet.assignments.chaptersLabel': 'глава(ы)',
  'menu.myAccount.subTitle': 'Здесь находится ваше учебное заведение',
  'menu.myAccount.subTitleNotAvailable': 'Вы сможете добавить учебное заведение позже, когда вам будет удобно.',
  'schoolInfoCard.toastMessage': 'Университет сохранён',
  'aet.review.threeDotMenu.askAI': 'Спросить ИИ',
  'aet.home.suggestedRemediationSubtitle': 'Просматривайте тематические видео и выполняйте практические задания, чтобы уверенно освоить материалы курса.',
  'aet.home.laggedQuestionLabel': 'Отмеченные вопросы',
  'aet.home.correctAnswer': 'Правильный ответ',
  'aet.home.incorrectAnswer': 'Самый распространённый неверный ответ',
  'aet.home.behaviourTrendsLabel': 'Аналитика по вопросу',
  'aet.home.strugglingStudentsLabel': 'Студенты, испытывающие трудности',
  'aet.home.patternsInStudensAiLabel': 'Тенденции использования ИИ студентами',
  'aet.home.questionLabel': 'Вопрос',
  'aet.home.studentAskingSimilarQuestions': 'Студенты, задающие похожие вопросы',
  'aet.home.assignmentDifficultQuestions': 'Сложные вопросы',
  'aet.home.behaviorTrends': 'Аналитика по вопросу',
  'aet.home.behaviors': 'Показатели успеваемости',
  'aet.home.mostDifficultTopics': 'Самые сложные вопросы',
  'aet.home.commentsFromStudentLabel': 'Комментарии студентов',
  'aet.home.disregard': 'Игнорировать',
  'aet.home.reportAsInaccurate': 'Сообщить о неточности',
  'aet.home.Flagged': 'Помечено',
  'aet.home.reportQuestionTitle': 'Сообщить о проблеме с вопросом',
  'aet.home.reportQuestionLabel': 'Что было не так с этим вопросом?',
  'aet.home.showComments': 'Показать комментарии',
  'aet.home.studentReports': 'отчёты по студентам',
  'aet.home.placeholderText': 'Поясните…',
  'aet.home.reportQuestion.notRelevant': 'Не относится к теме',
  'aet.home.reportQuestion.notCorrect': 'Ошибочен',
  'aet.home.reportQuestion.unsafe': 'Небезопасно/вредно',
  'aet.home.reportQuestion.somethingElse': 'Другая причина',
  'aet.home.StudentDetails.assistedByAI': 'При поддержке ИИ',
  'aet.home.strugglingStudents.emptyStateTitle': 'Сейчас нет студентов, испытывающих трудности',
  'aet.home.strugglingStudents.emptyStateDescription': 'Проверьте позже.',
  'aet.home.overallStatus.excelling': 'Выдающиеся результаты',
  'aet.home.overallStatus.fallingBehind': 'Есть отставание',
  'aet.home.overallStatus.keepingUp': 'Держат темп',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Показать только «Сложные вопросы»',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Показать только «Студенты, испытывающие трудности»',
  'aet.home.viewQuestionInAssignment': 'Просмотреть вопрос в задании',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Неверные первые попытки',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Множество неверных попыток',
  'aet.home.insightRisk.lowConfidence': 'Низкий уровень уверенности',
  'aet.home.insightRisk.mediumConfidence': 'Средний уровень уверенности',
  'aet.home.insightRisk.lowEngagement': 'Низкая активность',
  'aet.home.insightRisk.countOfStudents': '{count} из {total} студентов',
  'aet.home.insightRisk.na': 'Нет данных',
  'aet.home.strugglingStudentsHereLabel': 'Здесь у студентов возникают затруднения',
  'aet.home.insightRisk.didNotAttempt': 'Не начато',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'Интеграция с LMS',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.',
  'aet.unlinkCourse.title': 'Unlink Pearson and [LMS] courses?',
  'aet.unlinkCourse.warning.accessInfoBeforePearson': 'Your Pearson course will be unlinked from your [LMS] course. You can still access the Pearson course by signing into ',
  'aet.unlinkCourse.warning.pearsonLinkLabel': 'Pearson',
  'aet.unlinkCourse.warning.accessInfoAfterPearson': ' with your linked account.',
  'aet.unlinkCourse.warning.relinkInfo': 'If no students are enrolled in the Pearson course you’re unlinking, you can link it again with the same [LMS] course.',
  'aet.unlinkCourse.beforeContinueHeading': 'Before you continue:',
  'aet.unlinkCourse.beforeContinueItem': 'If you link your [LMS] course with a different Pearson course, delete all Pearson grades from your [LMS] gradebook and any areas or modules in your LMS course. Otherwise, your [LMS] course may have duplicate grades.',
  'aet.unlinkCourse.inProgressCta': 'Unlinking...',
  'aet.unlinkCourse.okCta': 'OK',
  'aet.unlinkCourse.success.title': 'Unlink successful',
  'aet.unlinkCourse.success.heading': 'Your course has been unlinked from your LMS',
  'aet.unlinkCourse.success.descriptionBeforePearson': 'You can still access the course by signing into ',
  'aet.unlinkCourse.success.descriptionAfterPearson': ' with your Pearson account.',
  'aet.unlinkCourse.failure.title': 'Couldn\'t unlink course',
  'aet.unlinkCourse.failure.paragraph1': 'Your course couldn\'t be unlinked from your LMS. Wait a few minutes and try again.',
  'aet.unlinkCourse.failure.paragraph2': 'If the problem continues, contact Pearson Support.'
};

export default ru;
